export default __webpack_public_path__ + "static/media/IMG_1972.e862571e.JPG";